module.exports = __webpack_public_path__ + "resources/images/logoCAV-470151fe19569f37967d02668fd4dad2-cache.jpg";